// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27s-q","questions":"styles_questions__zcHjf","footer":"styles_footer__1u68W"};